import { getUiPictureTemplate } from '@front-box/Media/UiPicture/UiPictureTemplate'
import { UiButtonVanilla } from '@front-box/Buttons/UiButton/UiButtonVanilla'
import UiModal from '../UiModal/UiModal'
import { createElement } from '../../utils/render'

const images = {
  sm: {
    img: {
      '1x': 'https://cdn.skillbox.pro/wbd-front/landgen-static/popups/tg-modal/tg-modal@1x.png',
      '2x': 'https://cdn.skillbox.pro/wbd-front/landgen-static/popups/tg-modal/tg-modal@2x.png'
    },
    webp: {
      '1x': 'https://cdn.skillbox.pro/wbd-front/landgen-static/popups/tg-modal/tg-modal.webp',
      '2x': 'https://cdn.skillbox.pro/wbd-front/landgen-static/popups/tg-modal/tg-modal@2x.webp'
    }
  }
}

const getData = (type) => {
  switch (type) {
    case 'telegram':
      return {
        title: 'Чтобы мы&nbsp;могли вам написать, запустите бота в&nbsp;Telegram',
        description: 'Telegram не&nbsp;позволяет отправлять сообщения первым. Запустите бота&nbsp;&mdash; и&nbsp;наш менеджер свяжется с&nbsp;вами.'
      }
    default:
      return {
        title: 'Больше скидок и&nbsp;интересных событий в&nbsp;нашем Telegram-боте',
        description: 'Подпишитесь на&nbsp;Telegram-бота, чтобы не&nbsp;пропустить скидки и&nbsp;узнать больше об&nbsp;обучении в&nbsp;Skillbox'
      }
  }
}

const getCommunicationModalTemplate = ({ title, description, href }) => {
  return (
    `<div class="communication-modal__wrapper">
      ${getUiPictureTemplate({
        imagesData: images,
        className: 'communication-modal__picture',
        width: 120,
        height: 120,
        isLazy: false,
        decoding: 'sync'
      })}

      <h2 class="communication-modal__title t t--1">
        ${title}
      </h2>

      <p class="communication-modal__description f f--14">
        ${description}
      </p>

      ${UiButtonVanilla({
        size: 'big',
        stretchMode: 'sm-max',
        title: 'Перейти в Telegram',
        href,
        classes: 'communication-modal__button',
        attrs: 'target=_blank'
      })}
    </div>`
  )
}

class CommunicationModal extends UiModal {
  constructor(template, blockName) {
    super(template, {
      wrapperClass: 'communication-modal',
      isIndent: false,
      blockTriggerName: blockName
    });
  }

  beforeMounted() {
    this.element.querySelector('.communication-modal__button').addEventListener('click', this._clickButtonHandler);
  }

  beforeUnmounted() {
    this.element.querySelector('.communication-modal__button').removeEventListener('click', this._clickButtonHandler);
  }

  _clickButtonHandler = () => {
    window.$analytics?.push('communication-modal-click', { blockName: this.blockTriggerName });
    this.close();
  }
}

export const showCommunicationModal = (type, blockName, phone) => {
  const data = getData(type)
  const href = `https://refer.id/?bot=skillbox_main_bot&platform=telegram&verbose_name=Skillbox&bot_avatar=https://getmybot.storage.yandexcloud.net/uploads/bot_avatars/skb.png&n=173798&c=11203&phone=${phone?.replace(/\D+/g, '')}`
  const template = createElement(getCommunicationModalTemplate({...data, href }))

  new CommunicationModal(template, blockName).init()
}
